module.exports = __webpack_public_path__ + "static/media/ch-play.a55ca775.svg";